<script>
  import { LayerCake, Svg, flatten } from 'layercake';
  import { stack } from 'd3-shape';
  import { scaleOrdinal } from 'd3-scale';
  import { format, precisionFixed } from 'd3-format';
  import { timeParse, timeFormat } from 'd3-time-format';

  import AxisX from './components/AxisX.svelte';
  import AxisY from './components/AxisY.svelte';
  import AreaStacked from './components/AreaStacked.svelte';

  import { onMount } from 'svelte';

  // Loads csv data as json using @rollup/plugin-dsv
  import data from './data/vaxdata.csv';

  const xKey = 'date';
  const yKey = [0, 1];
  const zKey = 'key';


  let casenumberfontsize = "50px";
  let shotcountfontsize = "18px";
  let totalfontsize = "24px";
  let chartcontainerheight = "200px";
  let charttopheight = "0px;"
  let shownumbercontainer = true;
  let showcharttopcontainer = false;
  let chartcontainerwidth = "60%";
  let numbercontainerwidth = "37%";

  let x_ticks = [];
  let num_y_ticks = 3;

  const parseDate = timeParse('%Y-%m-%d');

  x_ticks.push(parseDate('2021-06-01'));
  x_ticks.push(parseDate('2021-12-01'));

  const seriesNames = Object.keys(data[0]).filter(d => d !== xKey);


  const vax_color = '#05546E';
  const boost_color = '#0BA82F'

  const seriesColors = [boost_color, vax_color];

  data.forEach(d => {
    d[xKey] = typeof d[xKey] === 'string' ? parseDate(d[xKey]) : d[xKey];
    seriesNames.forEach(name => {
      d[name] = +d[name];
    });
  });

  /* --------------------------------------------
   * Create a stacked data structure
   */
  const stackData = stack()
    .keys(seriesNames);

  const series = stackData(data);

  const formatTickX = timeFormat('%-m/%-d/%y')
  const formatTickY = d => format(`.${precisionFixed(d)}s`)(d) + '%';

  let boosted_percent = data[0].boosted;
  let vax_percent = data[0].boosted + data[0].vaxed;


  function set_font_sizes() {
      
    var maindiv = document.getElementById('containerbase');
    var mainwidth = maindiv.offsetWidth;

    if (mainwidth <= 250) {
      casenumberfontsize = "20px";
      shotcountfontsize = "12px";

      chartcontainerwidth = "99%";
      numbercontainerwidth = "0%";

      shownumbercontainer = false;
      showcharttopcontainer = true;


      chartcontainerheight = "130px";
      charttopheight = "50px";


      return 0;
    }

    if (mainwidth <= 300) {
      casenumberfontsize = "28px";
      shotcountfontsize = "18px";

      chartcontainerwidth = "60%";
      numbercontainerwidth = "37%";

      shownumbercontainer = true;
      showcharttopcontainer = false;

      chartcontainerheight = "160px";
      charttopheight = "0px";

      return 0;

    } 


    if (mainwidth <= 350) {
      casenumberfontsize = "32px";
      shotcountfontsize = "20px";
      chartcontainerwidth = "60%";
      numbercontainerwidth = "37%";
      shownumbercontainer = true;
      showcharttopcontainer = false;

      chartcontainerheight = "160px";
      charttopheight = "0px";
      return 0;

    }

    casenumberfontsize = "36px";
    shotcountfontsize = "24px";

    chartcontainerwidth = "60%";
    numbercontainerwidth = "37%";
    shownumbercontainer = true;
    showcharttopcontainer = false;
    chartcontainerheight = "160px";
    charttopheight = "0px";

  }

   var pymChild = new pym.Child();

  function setExplicitHeight(height) {  
    // We can ignore pym's estimate of the height and send our own. 
    pymChild.sendMessage('height', height);
    console.log("Pym: sent user chosen height of " + height);
  }


    onMount(() => {
      window.addEventListener('resize', set_font_sizes);
      
      setTimeout(set_font_sizes, 100);
      setExplicitHeight(200);


  });
</script>

<style>

  .chart-container {
    margin-bottom:10px;
    width: 99%;
    font-weight:400;
  }

  body {
    padding: 0px;
  }

  .chart-container-exterior {
    max-width: 400px;
    height: 200px;
    float:right;
    margin-top: 10px;
  }

  .chart-top {
    margin:0px;
    padding: 0px;
  }

  .number-container {
    float:left;
    font-weight: 400;

  }

  .casenumber {
    display: flex;
  justify-content: center;
  align-items: center;
    font-family:'Roboto';
    height: 110px;
    margin-top:-10px;
    padding-top:0px;
  }
  .casedate {
    font-family:'Roboto';
    height: 85px;
    text-align: center;
  }
  

  .numberdisplay {
    background-color:#CCC;
  }

  .wholecontainer {
    max-width: 500px;
  }

  .casenumbertop {
    width: 99%;
    text-align: center;
    font-weight:700;
    margin-top:0px;
    padding-top:0px;


  }

  .casedatetop {
    width: 99%;
    text-align: center;

  }

</style>


<div id="containerbase" class="wholecontainer">

<div class="float-container">


{#if shownumbercontainer}
  <div class="number-container" style="width: 37%;">
    <div class="number-top">
      <div class="casenumber">
        <div style="font-size:{casenumberfontsize}; font-weight:700; text-align:center;"><span style="color:{ boost_color }">{ boosted_percent }%</span><br><span style="font-weight:400; font-size:{shotcountfontsize};">Boosted</span></div>
        
      </div>
    </div>
    <div class="casedate">
      <div style="font-size:{casenumberfontsize}; font-weight:700; text-align:center;"><span style="color:{ vax_color }">{ vax_percent }%</span><br><span style="font-weight:400; font-size:{shotcountfontsize};">Vaccinated</span></div>
    </div>
  </div>
{/if}


{#if showcharttopcontainer}

  <div class="chart-top" style="height: {charttopheight};">


      <div class="casenumbertop">
        <span style="font-size:{casenumberfontsize}; font-weight:700;"><span style="color:{ boost_color }">{boosted_percent}%</span> Boosted</span>
      </div>
            
    <div class="casedatetop">

      <span style="font-size:{shotcountfontsize};"><span style="color:{ vax_color }">{ vax_percent }%</span> Vaccinated</span>
      
    </div>


  </div>
{/if}

<div class="chart-container-exterior" style="width: {chartcontainerwidth};">



  <div class="chart-container" style="height: {chartcontainerheight};">
    <LayerCake
      padding={{ top: 0, right: 0, bottom: 20, left: 17 }}
      x={d => d.data[xKey]}
      y={yKey}
      z={zKey}
      zScale={scaleOrdinal()}
      zDomain={seriesNames}
      zRange={seriesColors}
      flatData={flatten(series)}
      data={series}
      yDomain={ [0, 100] }
    >
      <Svg>
        <AxisX
          formatTick={formatTickX}
          tickMarks={true}
          gridlines={false}
          ticks={x_ticks}
          snapTicks={false}
        />
        <AxisY
          formatTick={formatTickY}
          ticks={num_y_ticks}
        />
        <AreaStacked/>
      </Svg>
    </LayerCake>

  </div>

</div>

</div>

</div>

